import { API } from '@factorin/container.macro';

import { state } from './state';
import { errorFormatter } from './errorFormatter';
import { apiMiddleware } from './middleware';
import { callApi, wrapApi } from './rest';


export * from './rest';

export const api = {
    API: {
        errorFormatter,
        state,
        call: callApi,
        wrap: wrapApi,
    },

    config: {
        apiPath: '/api',
        pathPrefix: '',
    },
    state: {
        middleware: [
            apiMiddleware,
        ],
    },
};

export const apiCall = (apiCall, callArgs) => API.call(apiCall, callArgs);

if (process.env.NODE_ENV === 'development' && module.hot) {
    api.API.$updateHot = ({ state: oldState }, API) => ({
        ...API,
        state: oldState,
    });
}
